/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useInput, Labeled } from 'react-admin';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';

import { TextField, Chip, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'start',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5),
    },
  },
}));

const TagsInput = (props) => {
  const classes = useStyles();

  const inputTag = useRef();

  const {
    input: { onChange, value },
  } = useInput(props);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const tagsValues = [...value];
      _forEach(inputTag.current.value.split(';'), (v) => {
        if (!_includes(tagsValues, v)) tagsValues.push(v.trim());
      });

      onChange(tagsValues);
      inputTag.current.value = '';
    }
  };

  const handleDelete = (tag) => {
    let tags = [...value];
    let index = tags.indexOf(tag);
    if (index === -1) return;

    tags.splice(index, 1);

    onChange(tags);
  };

  const { label } = props;

  return (
    <Labeled label={label}>
      <React.Fragment>
        <div className={classes.root}>
          {_map(value, (t) => (
            <Chip key={t} label={t} onDelete={() => handleDelete(t)} />
          ))}
        </div>
        <TextField
          type="text"
          onKeyPress={handleKeyPress}
          inputRef={inputTag}
          placeholder="Add new tag"
          helperText="You can add multiple tags at once separated by ;"
        />
      </React.Fragment>
    </Labeled>
  );
};

TagsInput.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string,
  label: PropTypes.string,
};

TagsInput.defaultProps = {
  record: {},
  label: 'Tags',
};

export default TagsInput;
